import styled from 'styled-components';
import {dFlexCenter, mobileMedia} from '../../../../../globalVariables/GlobalVariables';

export const actionsBar = styled.div`
    ${dFlexCenter};
    padding: var(--space-xl) var(--space-md);
    gap: var(--space-lg);
    background: var(--TA-color-bg-base);
    border-top: 1px solid var(--TA-color-border-subtle);
    ${mobileMedia} {
        display: none;
    }
`;
